export const businessTitles = [
    "",
    "",
    "Nombre",
    "Dirección",
    "Web"
];